// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-switcher {
  position: relative;
  display: inline-block;
}

.language-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  color: var(--main-text-color);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.language-button:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.language-flag {
  font-size: 16px;
  line-height: 1;
}

.language-flag-image {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 1px;
  vertical-align: middle;
}

.language-name {
  flex: 1 1;
  text-align: left;
  font-weight: 500;
}

.language-arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
  opacity: 0.7;
}

.language-arrow.open {
  transform: rotate(180deg);
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 150px;
  margin-top: 4px;
  overflow: hidden;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
}

.language-option:hover {
  background-color: #f5f5f5;
}

.language-option.active {
  background-color: var(--main-text-color-highligth);
  color: white;
}

.language-option .language-flag {
  font-size: 16px;
}

.language-option .language-name {
  flex: 1 1;
  font-weight: 500;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .language-button {
    min-width: 100px;
    padding: 6px 10px;
  }
  
  .language-button .language-name {
    display: none;
  }
  
  .language-dropdown {
    right: -20px;
  }
}

/* Close dropdown when clicking outside */
.language-switcher.open::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/components/header/LanguageSwitcher.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd","sourcesContent":[".language-switcher {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.language-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  color: var(--main-text-color);\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  min-width: 120px;\r\n}\r\n\r\n.language-button:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.language-flag {\r\n  font-size: 16px;\r\n  line-height: 1;\r\n}\r\n\r\n.language-flag-image {\r\n  width: 20px;\r\n  height: 14px;\r\n  object-fit: cover;\r\n  border-radius: 1px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.language-name {\r\n  flex: 1;\r\n  text-align: left;\r\n  font-weight: 500;\r\n}\r\n\r\n.language-arrow {\r\n  font-size: 12px;\r\n  transition: transform 0.3s ease;\r\n  opacity: 0.7;\r\n}\r\n\r\n.language-arrow.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.language-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  min-width: 150px;\r\n  margin-top: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.language-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  background: none;\r\n  border: none;\r\n  color: #333;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  text-align: left;\r\n}\r\n\r\n.language-option:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.language-option.active {\r\n  background-color: var(--main-text-color-highligth);\r\n  color: white;\r\n}\r\n\r\n.language-option .language-flag {\r\n  font-size: 16px;\r\n}\r\n\r\n.language-option .language-name {\r\n  flex: 1;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .language-button {\r\n    min-width: 100px;\r\n    padding: 6px 10px;\r\n  }\r\n  \r\n  .language-button .language-name {\r\n    display: none;\r\n  }\r\n  \r\n  .language-dropdown {\r\n    right: -20px;\r\n  }\r\n}\r\n\r\n/* Close dropdown when clicking outside */\r\n.language-switcher.open::before {\r\n  content: '';\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 999;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
